import React from 'react';
import PropTypes from 'prop-types';

import './pion-thumbnail.scss';

type PionThumbnailPropsType = {
  url: string;
  caption?: string;
};
const PionThumbnail = ({ url, caption }: PionThumbnailPropsType) => (
  <div className='pion-thumbnail'>
    <img data-testid='pion-thumbnail-img' src={url} alt={caption} />
  </div>
);

PionThumbnail.propTypes = {
  url: PropTypes.string.isRequired,
  caption: PropTypes.string,
};

export default PionThumbnail;
